module.exports = __webpack_public_path__ + "img/isbar_clinical.8468f40e.jpg";